import { ProductDisclaimer, type ProductFamily } from 'product/types/Product'
import { getMainFamily } from 'product/utils/getMainFamily/getMainFamily'
import { useMemo } from 'react'

interface UseSizeGuideProps {
	readonly productFamilies: ProductFamily[]
	readonly productColorDisclaimer: ProductDisclaimer | undefined
	readonly isProductColorMultisize: boolean
}
export const useSizeGuide = ({
	productFamilies,
	productColorDisclaimer,
	isProductColorMultisize,
}: UseSizeGuideProps) => {
	const { hasSizeGuide } = useMemo(
		() => getMainFamily({ families: productFamilies }),
		[productFamilies]
	)
	const showSizeGuideByDisclaimer = useMemo(
		() =>
			(!productColorDisclaimer ||
				productColorDisclaimer === ProductDisclaimer.SizeguideDisclaimer) &&
			isProductColorMultisize,
		[productColorDisclaimer, isProductColorMultisize]
	)
	return {
		shouldShowSizeGuide: hasSizeGuide && showSizeGuideByDisclaimer,
	}
}
